<template>
  <div v-if="readOnly">
    <div v-if="model.properties.dropdown && model.properties.dropdownMultiSelect" class="mb-6">
      <!--Selected items-->
      <div class="selected-items w-full border border-black bg-graylight-100 rounded p-4 flex flex-wrap">
        <div v-for="(item, index) in multiSelected" :key="index"
          class="selected-item flex items-center bg-bluegray-200 rounded-full px-4 py-2 mb-2 mr-2">
          <div v-html="getSelectedById(item)" />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="model.properties.dropdown && model.properties.dropdownMultiSelect" class="mb-6">
      <!--Selected items-->
      <div class="selected-items w-full border border-black rounded p-4 flex flex-wrap">
        <div v-for="(item, index) in multiSelected" :key="index"
          class="selected-item flex items-center bg-bluegray-200 rounded-full px-4 py-2 mb-2 mr-2">
          {{ getSelectedById(item) }}
          <button @click="removeItem(item)" class="remove-item items-center ml-2">
            <font-awesome-icon icon="times" />
          </button>
        </div>
      </div>
      <!--Toggle dropdownlist-->
      <div ref="dropdownMenu" class="w-1/2">
        <div class="w-full border rounded p-2 mt-4 flex justify-between" @click="toggleDropdown()">
          <span>Velg</span>
          <span class="ml-auto"><font-awesome-icon icon="caret-down" /></span>
        </div>
        <!--Dropdownlist-->
        <div v-if="isDropdownOpen" class="dropdown-options w-full border mt-1">
          <!--Flat-->
          <div v-if="!model.properties.multiLevel">
            <div v-for="(item, index) in model.properties.selectable" :key="index" class="option p-2">
              <label class="flex">
                <input type="checkbox" :value="item.value"
                  class="custom--inputbox__checkbox flex-grow-0 flex-shrink-0 mt-0.5 mb-0.5" @change="toggleItem(item)"
                  :checked="multiSelected.includes(item.value)" />
                <span class="flex justify-between text-lg text-left mb-0 self-center">{{ item.text }}</span>
              </label>
            </div>
          </div>
          <!--Multilevel-->
          <div v-else>
            <div v-for="item in model.properties.selectable" :key="item.value" class="option p-2">
              <span class="font-bold">{{ item.text }}</span>
              <div v-for="subItem in item.children" :key="subItem.value">
                <label class="flex">
                  <input type="checkbox" :value="subItem.value"
                    class="custom--inputbox__checkbox flex-grow-0 flex-shrink-0 mt-0.5 mb-0.5"
                    @change="toggleItem(subItem)" :checked="multiSelected.includes(subItem.value)" />
                  <span class="flex justify-between text-lg text-left mb-0 self-center">{{ subItem.text }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isDropdownOpen: false,
      isSaving: false,
      multiSelected: this.model.properties.multiSelected === null ? [] : this.model.properties.multiSelected,
      selectable: this.model.properties.selectable,
    };
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    noBorderLayout: {
      type: Boolean,
      required: false,
    },
  },
  components: {},
  methods: {
    save() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.model.contentGuid,
          value: this.multiSelected,
          type: this.type,
          pageId: this.pageId,
          relationRule: this.model.properties.relationRule,
        }),
      };
      const self = this;
      this.isSaving = true;
      fetch(`${window.location.origin}/api/schema/SaveSchemaItem`, requestOptions)
        .then(() => {
          this.$emit('onSave');
          this.$emit('getSchema');
        }).then(() => {
          self.isSaving = false;
          this.$toast.open({
            message: 'Lagret',
            type: 'success',
            dismissible: true,
          });
        });
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdownMenu.contains(event.target)) {
        this.isDropdownOpen = false;
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    removeItem(item) {
      // Fjern valgt element
      const index = this.multiSelected.indexOf(item);
      if (index !== -1) {
        this.multiSelected.splice(index, 1);
      }
      this.save();
    },
    toggleItem(item) {
      const index = this.multiSelected.indexOf(item.value);
      if (index === -1) {
        // Add element if not already selected
        this.multiSelected.push(item.value);
      } else {
        // Remove element if already selected
        this.multiSelected.splice(index, 1);
      }
      this.save();
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    // Get names for selected items
    getSelectedById(id) {
      function findText(items, id) {
        let result = null;

        items.forEach((item) => {
          if (result) return;
          if (item.value === id && !item.children) {
            result = item.text;
          } else if (item.children && item.children.length) {
            const childResult = findText(item.children, id);
            if (childResult) {
              result = childResult;
            }
          }
        });
        return result;
      }

      // Recursive call
      return findText(this.selectable, id) ?? id;
    },
  },
};
</script>
